import React from 'react';

export default function ChatPendingFiles({ files, onRemoveFile, className = '' }) {
    if (!files?.length) {
        return null;
    }

    const containerClassName = className
        ? `chat__pending-files ${className}`
        : 'chat__pending-files';

    return (
        <div className={containerClassName}>
            {files.map((fileItem, index) => (
                <div className="chat__pending-file-item" key={`${fileItem.file.name}_${fileItem.file.size}_${index}`}>
                    <div className="chat__pending-file-thumb">
                        {fileItem.mediaType === 'image' && fileItem.previewSrc && (
                            <img className="chat__pending-file-thumb__media" src={fileItem.previewSrc} alt={fileItem.file.name} />
                        )}
                        {fileItem.mediaType === 'video' && fileItem.previewSrc && (
                            <video className="chat__pending-file-thumb__media" src={fileItem.previewSrc} />
                        )}
                    </div>
                    <div className="chat__pending-file-info text_default_gray">
                        {fileItem.extension}, {fileItem.formattedSize}
                    </div>
                    <div className="chat__pending-file-remove" onClick={() => onRemoveFile(index)} />
                </div>
            ))}
        </div>
    );
}
